import { FleetrifyBgs } from "../../../assets/video";
import { FleetrifyInputField } from "../../../components/Input/input";
import { FleetrifyButton } from "../../../components/Button/customButton";
import { fleetrifyIcons } from "../../../assets/icons/icons";
import CarouselCard from "../../../components/Carousel";
import { useForgotPasswordController } from "../../../controllers/useForgotPasswordComtroller";

const ForgotPassword = () => {
  const slides = [
    { title: "Welcome to Fleetrify", description: "Login to manage logistics and fleet operations" },
    { title: "Real-time Fleet Insights", description: "Get live updates and analytics on every vehicle in your fleet" },
    { title: "Simplify Logistics Management", description: "Automate routing, tracking, and reporting — all in one platform" },
  ];

  const { email, setEmail, isEmailValid, isLoading, handleSubmit } = useForgotPasswordController();

  return (
    <div className="relative flex flex-col lg:flex-row min-h-screen items-center justify-center lg:bg-transparent bg-gray-100">

      {/* video section */}
      <div className="relative w-full lg:w-[45%] h-screen lg:h-screen order-2 lg:order-none">
        <video
          className="absolute inset-0 w-full h-full object-cover"
          autoPlay
          muted
          loop
          playsInline
        >
          <source src={FleetrifyBgs} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="absolute inset-0 bg-black opacity-50 z-10"></div>
        <div className="absolute z-20 inset-0 flex items-center justify-center">
          <CarouselCard slides={slides} />
        </div>
      </div>

      {/* forgot password form */}
      <div className="w-full lg:w-[55%] flex justify-center items-center absolute lg:static z-30 px-5 top-0 bottom-0 my-auto">
        <form
          onSubmit={handleSubmit}
          className="w-[430px] sm:w-[340px] md:w-[500px] lg:w-[430px] max-w-full bg-white px-4 py-6 rounded"
        >
          <div className="space-y-6">
            <div className="space-y-2">
              <h2 className="text-2xl font-bold text-center text-[#143887]">
                Forgot Password
              </h2>
              <p className="text-base text-center mb-8">
                Enter your email for verification
              </p>
            </div>

            <div className="space-y-4">
              <label className="block text-[#4F4F4F] mb-1 font-bold text-base">
                Email
              </label>
              <FleetrifyInputField
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                type="email"
                id="email"
                icon={fleetrifyIcons.mailIcon}
                required
                placeholder="Enter Email"
                className="mt-1"
              />
            </div>
          </div>

          <FleetrifyButton
            type="submit"
            loading={isLoading}
            disabled={!isEmailValid}
            className="w-full mt-6"
          >
            Send OTP
          </FleetrifyButton>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
